module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.ff423a4251cf29865555.svg";


//////////////////
// WEBPACK FOOTER
// /usr/local/app/src/assets/fonts/glyphicons-halflings-regular.svg
// module id = ../../../../../src/assets/fonts/glyphicons-halflings-regular.svg
// module chunks = 2